import {
  StatusErrorMessageEnum,
  StatusInformationMessageEnum,
  StatusService,
} from './status.service';
import { Injectable } from '@angular/core';
import { IAuthenticationResponse } from '../../interfaces/IAuthenticationResponse';
import { IAuthenticationRequest } from '../../interfaces/IAuthenticationRequest';
import { Router } from '@angular/router';
import { BaseService } from "../caronte-base/base.service";
import { switchMap, finalize } from "rxjs/operators";
import { catchError, map, Observable, throwError, from } from "rxjs";
import { RouteUtils } from "../../../utils/route.utils";
import { SessionStorageEnum } from "../../enums/sessionStorage.enum";
import { RecaptchaService } from "../recaptcha/recaptcha.service";

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    private recaptchaService: RecaptchaService,
    private router: Router,
    private statusService: StatusService,
    private baseService: BaseService
  ) {}

  userRequest: IAuthenticationRequest | null = null;
  userLogged: IAuthenticationResponse | null = null;

  private interval: any;
  private isLoggingIn = false;

  logoff() {
    this.userLogged = null;
    this.userRequest = null;
    clearInterval(this.interval);
    this.router.navigateByUrl('');
  }

  private startTimer() {
    this.interval = setInterval(() => {
      if (this.statusService.timeLeft > 0) {

        this.statusService.showTimeLeft =
          this.statusService.retryLogin == 0 && this.statusService.timeLeft <= 30;


        this.statusService.timeLeft--;
      } else {
        this.userRequest = null;
        this.statusService.retryLogin = 3;
        this.statusService.showTimeLeft = false;
        this.router.navigateByUrl('');
        clearInterval(this.interval);
        this.removeAuthSessionStorage();
        this.statusService.showToast('information', StatusInformationMessageEnum.SESSION_EXPIRED);
      }
    }, 1000);
  }

  private grantCredentials(request: IAuthenticationRequest, recaptchaToken: string): Observable<IAuthenticationResponse> {
    return this.baseService
      .post(
        RouteUtils.ENTRYPOINTS.AUTH,
        null,
        request,
        { 'x-recaptcha-token': recaptchaToken }
      )
      .pipe(
        map((auth) => {
          this.userLogged = auth.data as IAuthenticationResponse;
          this.statusService.timeLeft = this.statusService.tokenTimeExpired;
          if (this.interval) clearInterval(this.interval);
          this.statusService.showTimeLeft = false;
          this.setAuthSessionStorage(auth.data);
          this.startTimer();
          return auth.data;
        }),
        catchError((err) => {
          this.userLogged = null;
          this.userRequest = null;
          this.statusService.showTimeLeft = false;
          this.statusService.showError = true;
          this.removeAuthSessionStorage();
          switch (err.status) {
            case 401:
              this.statusService.showToast('error', StatusErrorMessageEnum.INVALID_CREDENTIALS);
              break;
            case 500:
            default:
              this.statusService.showToast('error', StatusErrorMessageEnum.INTERNAL_SERVER_ERROR);
              break;
          }
          return throwError(() => err);
        })
      );
  }

  login(request: IAuthenticationRequest, success: () => void, error: (err: any) => void): void {

    if (this.isLoggingIn) {
      return;
    }
    this.isLoggingIn = true;

    from(this.recaptchaService.getToken('login_attempt'))
      .pipe(
        switchMap(recaptchaToken => {
          this.userRequest = request;
          sessionStorage.setItem(SessionStorageEnum.USER_AUTH, JSON.stringify(request));
          return this.grantCredentials(this.userRequest, recaptchaToken);
        }),
        finalize(() => {

          this.isLoggingIn = false;
        })
      )
      .subscribe({
        next: () => {
          success();
        },
        error: (err: any) => {
          this.removeAuthSessionStorage();
          this.userLogged = null;
          this.userRequest = null;
          error(err);
        }
      });
  }

  reloginAfter403(): Observable<void> {
    if (!this.userRequest) {
      return throwError(() => new Error('Nenhum usuário em cache para relogin'));
    }

    return from(this.recaptchaService.getToken('relogin_attempt')).pipe(
      switchMap(recaptchaToken => this.grantCredentials(this.userRequest!, recaptchaToken)),
      map(() => void 0)
    );
  }

  private setAuthSessionStorage(auth: IAuthenticationResponse): void {
    sessionStorage.setItem(SessionStorageEnum.SESSION_ID, auth.sessionId);
    sessionStorage.setItem(SessionStorageEnum.ACCESS_TOKEN, auth.accessToken);
  }

  removeAuthSessionStorage(): void {
    sessionStorage.clear();
  }
}
